import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'semantic-ui-react'

class CustomCheckBox extends Component {
  render() {
    const { id, label, currentValue, onChange } = this.props

    return (
      <Checkbox
        id={id}
        name={id.toString()}
        label={label}
        indeterminate={currentValue === -1}
        checked={currentValue === 1}
        onChange={(e) => onChange(e, id)}
      />
    )
  }
}

CustomCheckBox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string,
  currentValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default CustomCheckBox
